import { type FC } from "react";

import { AddReactionIcon, EditAttributesIcon, PersonAddIcon, TextFieldsIcon } from "@moment/icons";

import { type HydratedCell } from "./HydratedCell";

export const ColumnTypeIcon: FC<{ type: HydratedCell["type"] }> = ({ type }) => {
	switch (type) {
		case "Text":
			return <TextFieldsIcon />;
		case "Reaction":
			return <AddReactionIcon />;
		case "Select":
			return <EditAttributesIcon />;
		case "Person":
			return <PersonAddIcon />;
		default: {
			const _exhaustive: never = type;
			throw new Error(`Unhandled column type: ${_exhaustive}`);
		}
	}
};
